export default __webpack_public_path__ + "static/media/busd-logo.171a77d8.png";